import { dictionariesApi } from "api/dictionaries/dictionariesApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useDictionaries = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.DICTIONARIES(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => dictionariesApi.fetch(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.DICTIONARIES(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, dictionaries: data?.data.data ?? [], total: data?.data.total ?? 0 };
};

export const useDictionariesOptions = () => {
  const { isLoading, dictionaries } = useDictionaries(0, 1_000_000);

  const options = dictionaries.map((x) => ({
    value: x.id.toString(),
    label: x.name,
  }));

  return { loading: isLoading, options };
};
